<div
  class="page min-h-screen bg-white font-sans text-gray-900 selection:bg-orange-100 selection:text-brand flex flex-col relative overflow-hidden"
  data-testid="dashboard-section"
>

  <!-- Confetti Animation -->
  <app-confetti-canvas [particleCount]="80"></app-confetti-canvas>

  <!-- Background Decor (Consistent with previous pages) -->
  <div
    class="blob-1 absolute top-0 right-0 w-[600px] h-[600px] bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 pointer-events-none translate-x-1/4 -translate-y-1/4"></div>
  <div
    class="blob-2 absolute bottom-0 left-0 w-[600px] h-[600px] bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 pointer-events-none -translate-x-1/4 translate-y-1/4"></div>

  <!-- Fixed Header -->
  <nav class="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-testid="dashboard-navbar">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Logo -->
        <a routerLink="/wizard/v2/landing" class="flex items-center hover:opacity-80 transition-opacity" data-testid="dashboard-logo">
          <img src="images/logo.png" alt="JustTeach Logo" class="h-6 w-auto"/>
        </a>

        <!-- User Info & Logout -->
        <div class="flex items-center gap-3" data-testid="dashboard-user-section">
          @if (userProfile$ | async; as user) {
            <div class="flex items-center gap-3" data-testid="dashboard-user-info">
              <div
                class="w-8 h-8 rounded-full bg-brand/10 text-brand flex items-center justify-center font-semibold text-sm uppercase"
                data-testid="dashboard-user-avatar"
              >
                {{ user.email.slice(0, 2) }}
              </div>
              <span class="text-sm text-gray-600 hidden sm:block" data-testid="dashboard-user-email">{{ user.email }}</span>
            </div>
          }
          <button
            (click)="logout()"
            class="flex items-center justify-center text-gray-500 hover:text-brand transition p-2 rounded-lg hover:bg-gray-50 cursor-pointer"
            title="Logout"
            data-testid="dashboard-logout-btn"
          >
            <lucide-icon [img]="icons.LogOut" class="w-5 h-5"></lucide-icon>
          </button>
        </div>
      </div>
    </div>
  </nav>

  <!-- Main Content -->
  <div class="flex-1 flex items-center justify-center px-4 pb-20 pt-16 relative z-10">
    <div class="max-w-lg w-full text-center">

      <!-- Success Card -->
      <div
        class="bg-white/80 backdrop-blur-2xl border border-white shadow-2xl shadow-orange-500/10 rounded-3xl p-8 sm:p-12 relative overflow-hidden group"
        data-testid="dashboard-success-card"
      >

        <!-- Decorative background glow inside card -->
        <div
          class="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-orange-200 rounded-full blur-3xl opacity-20 pointer-events-none"></div>

        <!-- Icon Wrapper -->
        <div class="relative inline-flex mb-8" data-testid="dashboard-success-icon">
          <div class="ping-animation absolute inset-0 bg-green-100 rounded-full opacity-75"></div>
          <div
            class="relative w-20 h-20 bg-green-500 rounded-full flex items-center justify-center shadow-lg shadow-green-500/30">
            <lucide-icon [img]="icons.Check" class="w-10 h-10 text-white stroke-3"></lucide-icon>
          </div>

          <!-- Floating Confetti Elements -->
          <div class="absolute -top-2 -right-4 text-yellow-400 bounce-delay-100">
            <lucide-icon [img]="icons.Sparkles" class="w-6 h-6 fill-current"></lucide-icon>
          </div>
          <div class="absolute -bottom-2 -left-4 text-orange-400 bounce-delay-700">
            <lucide-icon [img]="icons.Sparkles" class="w-4 h-4 fill-current"></lucide-icon>
          </div>
        </div>

        <!-- Text Content -->
        <h1 class="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight" data-testid="dashboard-heading">
          Thanks for your feedback!
        </h1>

        <p class="text-gray-600 text-lg leading-relaxed mb-4" data-testid="dashboard-description">
          You're now officially on the list to test <span class="text-orange-500 font-semibold">JustTeach early</span>.
          Your answers help us build something truly useful for teachers like you.
        </p>

        <!-- Info Box -->
        <div class="bg-gray-50 border border-gray-100 rounded-2xl p-4 mb-8 text-left flex items-center gap-3" data-testid="dashboard-info-box">
          <div class="w-10 h-10 bg-blue-100 rounded-full flex-shrink-0 flex items-center justify-center">
            <lucide-icon [img]="icons.Mail" class="w-5 h-5 text-blue-600"></lucide-icon>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600" data-testid="dashboard-info-text">
              We'll reach out soon with early access updates.
            </p>
          </div>
        </div>

        <!-- Footer -->
        <div class="pt-2" data-testid="dashboard-footer">
          <span class="text-xs font-semibold text-gray-400 uppercase tracking-widest inline-flex items-center gap-1">
            Made with <lucide-icon [img]="icons.Heart" class="w-3 h-3 text-red-400 fill-current mx-0.5"></lucide-icon> for teachers
          </span>
        </div>

      </div>
    </div>
  </div>
</div>
